/* eslint-disable camelcase */
import { Tabs as SparkTabs, TabList, TabButton, TabPanels, TabPanel } from '@uswitch/spark'
import React, { FC, ReactNode } from 'react'

import { trackSegment } from '~/utils/tracking'

import styles from './styles.module.css'

interface TabsProps {
  tabs: Array<{
    title: string
    body: ReactNode
  }>
  sku?: string | unknown
}

const tabClickedEvent = (sku: string | unknown, title: string) => {
  trackSegment('Element Clicked', {
    element_name: `More info tab opened - SKU: ${sku}`,
    element_text: `${title} more info tab opened`,
    element_type: 'button'
  })
}

const Tabs: FC<TabsProps> = ({ tabs, sku }) => (
  <div className={`us-container ${styles.wrapper}`} data-controller='tabs'>
    <SparkTabs>
      <TabList>
        {tabs.map((tab, index) => (
          <TabButton
            key={index}
            open={index === 0}
            data-action='click->tabs#click'
            data-tabs-target='button'
            data-tabs-index={index}
            onOpen={() => tabClickedEvent(sku, tab.title)}
            className={styles.button}
          >
            {tab.title}
          </TabButton>
        ))}
      </TabList>

      <TabPanels className={styles.panels}>
        {tabs.map((tab, index) => (
          <TabPanel key={index} open={index === 0} data-tabs-target='panel' data-tabs-index={index}>
            {tab.body}
          </TabPanel>
        ))}
      </TabPanels>
    </SparkTabs>
  </div>
)

export default Tabs
